// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__lF+RM","btnSlide":"About_btnSlide__zUAPs"};